/** **************************** Import Types ****************************** */
import {
  DOCS_REQUEST,
  DOCS_SUCCESS,
  DOCS_FAILURE,
} from "../types/aiDocs.types";

const initialState = {
  storeItemResponse: "",
  error: "",
  loading: false,
};

const AiDocsReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOCS_REQUEST:
      return {
        ...state,
        storeItemResponse: "",
        loading: true,
      };
    case DOCS_SUCCESS:
      return {
        ...state,
        storeItemResponse: action.payload,
        loading: false,
      };
    case DOCS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default AiDocsReducer;
